import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop({ type: Array, default: () => [] })
  children!: any[]

  get childrenSlots () {
    return this.children.reduce(
      (a, c) => {
        const slot = c.slot || 'default';
        // get or init slot array and push item
        (a[slot] || (a[slot] = [])).push(c)
        return a
      }, {})
  }
}
